import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import { TerritoriesDrawer } from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";

export default function Territories(param: any) {

  useEffect(() => {

    if (param.activeTab === "Territories") {
      teritorySelect()
    }
    searchFor = '';
    setsearchFor(searchFor);
  }, [param])


  let [searchFor, setsearchFor] = useState("");
  let [listingCount, setListingCount] = useState(0);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [territoryList, SetTerritoryListing] = useState<any>([]);
  let [TempTerritoryList, SetTempTerritory] = useState<any>([]);

  var payLoad = {
    pageNumber: 1,
    pageSize: 10
  }

  const teritory_Select = () => {

    if (searchFor.length > 0) {
      console.log(searchFor)

      console.log(TempTerritoryList)
      const temp = TempTerritoryList?.filter((listing: any) =>
        listing?.territoryName?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCurrency?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCode?.toLowerCase().includes(searchFor?.toLowerCase())
      );
      console.log(temp)
      listingCount = temp.length;
      setListingCount(listingCount)
      territoryList = temp.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber)
      SetTerritoryListing(territoryList)

    } else {
      SetTerritoryListing(TempTerritoryList);
    }
  }

  const teritorySelect = () => {
    var payload = {
    }
    systemListingService.territoryList(payload).then((res:any) => {
      TempTerritoryList = res
      SetTempTerritory(TempTerritoryList);

      territoryList = res.slice((1 - 1) * 10, (10 * 1));
      SetTerritoryListing(territoryList)

      listingCount = TempTerritoryList.length;
      setListingCount(listingCount)
    })
  }

  const onPageChange = (e: any) => {
    console.log(e)
    console.log(payLoad)

    payLoad.pageSize = e.pageSize
    payLoad.pageNumber = e.pageNumber

    if (searchFor.length > 0) {
      const temp = TempTerritoryList?.filter((listing: any) =>
        listing?.territoryName?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCurrency?.toLowerCase().includes(searchFor?.toLowerCase()) ||
        listing?.territoryCode?.toLowerCase().includes(searchFor?.toLowerCase())
      );

      territoryList = temp.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
      SetTerritoryListing(territoryList)
    } else {

      territoryList = TempTerritoryList.slice((payLoad.pageNumber - 1) * payLoad.pageSize, payLoad.pageSize * payLoad.pageNumber);
      SetTerritoryListing(territoryList)
    }
  }

  return (
    <div>

      <div className="content-card ws-12">

        <div className="card-header-row ws-12">
          <div className="card-title">Territories</div>
          <div className="card-header-actions">
            <span className="pt mt">
              {TempTerritoryList ? TempTerritoryList.length : 0} record(s) found
            </span>
            <button className="icon-btn info" type="button" onClick={() => setEditingOn((prev) => !prev)} >
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>
          </div>
        </div>

        {/* Filter – styled like FormatSourceCodesPage */}
        <div className="filter-row ws-12" style={{ padding: "10px 12px", borderRadius: 8, border: "1px solid #e5e7eb", marginBottom: 12, }}  >

          <div className="text-bold ws-12">Filter</div>
          <div className="ws-12">
            <input className="form-input ws-3" onChange={(e: any) => { setsearchFor(e.target.value); teritory_Select() }} placeholder="Filter by code, name, currency or region" value={searchFor} />
            <button className="icon-btn primary pbl" type="button" onClick={() => { teritorySelect() }}>  Search  </button>
          </div>


        </div>

        {/* Table */}
        <div className="table-wrapper ws-12">

          {territoryList.length > 0 && <><table className={editingOn ? "editing-on newTable" : " newTable"}>
            <thead>
              <tr>
                <th className="col-code forceSingleLine">Territory Code</th>
                <th className="forceSingleLine">Territory Name</th>
                <th className="col-currency forceSingleLine">Territory Currency</th>
                <th >DIM1</th>
                <th >DIM2</th>
                <th >DIM3</th>
                <th className="col-region">System Region</th>
                <th style={{ width: "13%" }}>Operations</th>
              </tr>
            </thead>
            <tbody>
              {territoryList.map((territoryRow: any) => (
                <tr key={territoryRow.territoryCode} className="pm">
                  <td >{territoryRow.territoryCode}</td>
                  <td >{territoryRow.territoryName}</td>
                  <td >{territoryRow.territoryCurrency}</td>
                  <td >{territoryRow.dim1TerritoryCodes}</td>
                  <td >{territoryRow.dim2TerritoryCodes}</td>
                  <td >{territoryRow.dim3TerritoryCodes}</td>
                  <td className="col-region">{territoryRow.systemRegion}</td>
                  <td >
                    <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }} >
                      <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} >
                        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 20h9" />
                          <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
                        </svg>
                      </button>
                      <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => editingOn && console.log("Delete territory", territoryRow.code)}>
                        <i className="icon-trash"> </i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {TempTerritoryList.length === 0 && (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center", padding: "12px" }} >
                    No records match your search.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

            <Pagination totalRow={listingCount} onPageChange={onPageChange} />
          </>}

          {TempTerritoryList.length === 0 && <div className="ws-12">
            <div className="alert alert-info ws-12 box" >No records to display</div>
          </div>}

        </div>

        <div className="add-row-wrapper" style={{ marginTop: 12, display: "flex", justifyContent: "flex-start", }}>
          <button className="btn-add-row" type="button" disabled={!editingOn} >
            + Add Territories
          </button>
        </div>
      </div> 

    </div>
  );
}; 
